import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {useNavigate} from 'react-router-dom'

import IndexNavbar from '../IndexNavbar'
import Footer from "../Footer";
import PageChange from '../PageChange'
import LandingPage from '../Pages/Landing';
import ResearchLines from '../Pages/ResearchLines';
import About from '../Pages/About';

import Snackbar from "@mui/material/Snackbar";
import Alert from '@mui/material/Alert';
import { TriangleBottom, TriangleTop } from '../Triangle';
import DisplayCourses from './DisplayCourses';

const Home = ({researchLineRef, aboutRef, coursesRef}) => {

    const { t } = useTranslation('global')

    const [loading, setLoading] = useState(true);

    const [openSnackbar, setOpenSnackbar] = useState(false);

    const handleAlert = () => {
        setOpenSnackbar((openSnackbar) => !openSnackbar);
    }
        
    useEffect(() => {
        const handleStart = () => setLoading(true);
        const handleComplete = () => setLoading(false);

        window.addEventListener('routeChangeStart', handleStart);
        window.addEventListener('routeChangeComplete', handleComplete);

        return () => {
            window.removeEventListener('routeChangeStart', handleStart);
            window.removeEventListener('routeChangeComplete', handleComplete);
        };
    }, []);
    
    useEffect(() => {
        const handlePageLoad = () => setLoading(false);
        if (document.readyState === 'complete') {
            setLoading(false);
        } else {
            window.addEventListener('load', handlePageLoad);
        }
        return () => {
            window.removeEventListener('load', handlePageLoad);
        };
    }, []);

    if (loading) {
        return (
            <PageChange />
        )
    } 
    else {
        return (
            <>
            <LandingPage />
            <section className="mt-48 md:mt-40 relative bg-blueGray-100">
              <div
                className="-mt-20 top-0 bottom-auto left-0 right-0 w-full absolute h-20"
                style={{ transform: "translateZ(0)" }}
              >
                <svg
                  className="absolute bottom-0 overflow-hidden"
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                  version="1.1"
                  viewBox="0 0 2560 100"
                  x="0"
                  y="0"
                >
                  <polygon
                    className="text-blueGray-100 fill-current"
                    points="2560 0 2560 100 0 100"
                  ></polygon>
                </svg>
              </div>
              <ResearchLines researchLineRef={researchLineRef} />
              <TriangleTop />
              <DisplayCourses coursesRef={coursesRef} />
              <TriangleBottom />
              <About aboutRef={aboutRef} handleAlert={handleAlert} />
            </section> 
            <Snackbar
              open={openSnackbar}
              autoHideDuration={3000}
              onClose={handleAlert}
              >
                <Alert
                  onClose={handleAlert}
                  severity="success"
                  variant="filled"
                  sx={{ width: '100%' }}
                >
                  {t('About.email_copy')}
                </Alert>
            </Snackbar>
          </>
        )
    }       
    
}

const Layout = ({children, researchLineRef, aboutRef, coursesRef}) => {
  const navigate = useNavigate();
  return (
    <>
      <IndexNavbar
          researchLineRef={researchLineRef}
          aboutRef={aboutRef}
          coursesRef={coursesRef}
          navigate={navigate}
      />
          <main>{children}</main>
      <Footer
        researchLineRef={researchLineRef}
        aboutRef={aboutRef}
        coursesRef={coursesRef}
        navigate={navigate}
      />
    </>
  )
}

export {Home, Layout}